import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {useInfiniteScroll} from "../../hooks/useInfiniteScroll";
import {getMemberPushAlarmHistories} from "../../api/alarmApi";
import {EmptyState} from "../../components/common/EmptyStateProps";
import {SearchTypes} from "../../types/common/search.types";
import LoadMoreButton from "../../components/common/LoadMoreButton";
import {formatTodayCompareDateTime} from "../../utils/format";

const AlarmListPage = () => {
    const navigate = useNavigate();
    const [expandedIds, setExpandedIds] = useState<Set<number>>(new Set());

    const toggleExpand = (id: number) => {
        setExpandedIds(prev => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    };
    const [searchTypes, setSearchTypes] = useState<SearchTypes>({
        startDate: "",
        endDate: "",
        status: "",
        category: "",
        page: 1,
        size: 5
    });

    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);

    const {
        accumulatedRows,
        showMoreButton,
        nextPage,
        appendPageData,
        resetPageData,
    } = useInfiniteScroll();


    const setCategory = (category : string) => {
        setSearchTypes(prev => ({ ...prev, category: category }));
    };

    const handleSearch = async () => {
        try {
            setLoading(true);
            const response = await getMemberPushAlarmHistories({
                ...searchTypes,
                page: 1
            });
            if (response?.data?.data) {
                resetPageData(response.data.data, searchTypes.size || 10);
            }
        } catch (err) {
            console.error('알림 내역 에러:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleLoadMore = async () => {
        try {
            setLoadingMore(true);
            const response = await getMemberPushAlarmHistories({
                ...searchTypes,
                page: nextPage,
            });
            if (response?.data?.data) {
                appendPageData(response.data.data, searchTypes.size || 10);
            }
        } catch (err) {
            console.error('더보기 에러:', err);
        } finally {
            setLoadingMore(false);
        }
    };

    useEffect(() => {
        const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (isIos) {
            if (window.webkit?.messageHandlers?.nativeApp) {
                window.webkit.messageHandlers.nativeApp.postMessage({ type: "clearBadge" });
            }
        }
    }, []);
    useEffect(() => {
        handleSearch();
    }, [searchTypes.category]);



    return (
        <>
            <header className="sub-header">
                <div className="header-inner">
                    <button
                        type="button"
                        className="backBtn"
                        onClick={() => navigate(-1)}
                    >
                        <span className="blind">뒤로가기</span>
                    </button>
                    <h1 className="subtitle">알림내역</h1>
                    <Link to="/alarmSetting">
                        <button type="button" className="settingBtn">
                            <span className="blind">설정</span>
                        </button>
                    </Link>
                </div>
            </header>
            <main className="container no-bottom-nav type_gray">
                <section>
                    <div className="filter-wrap">
                        <span className="filter">
                            <input type="radio" id="ALL" name="category" value=""
                                   checked={searchTypes.category === ''}
                                   onChange={(e) => setCategory(e.target.value)}
                            />
                            <label htmlFor="ALL">전체</label>
                        </span>
                        <span className="filter">
                            <input type="radio" id="CHARGE" name="category" value="CHARGE"
                                   checked={searchTypes.category === 'CHARGE'}
                                   onChange={(e) => setCategory(e.target.value)}
                            />
                            <label htmlFor="CHARGE">충전</label>
                        </span>
                        <span className="filter">
                            <input type="radio" id="USE" name="category" value="USE"
                                   checked={searchTypes.category === 'USE'}
                                   onChange={(e) => setCategory(e.target.value)}
                            />
                            <label htmlFor="USE">사용</label>
                        </span>
                        <span className="filter">
                            <input type="radio" id="POSTING" name="category" value="POSTING"
                                   checked={searchTypes.category === 'POSTING'}
                                   onChange={(e) => setCategory(e.target.value)}
                            />
                            <label htmlFor="POSTING">공고</label>
                        </span>
                    </div>
                </section>

                <section className="no-gap">
                    <div className="inner-box">
                        {!accumulatedRows || accumulatedRows.length === 0 ? (
                            <EmptyState message="알림내역이 비어있습니다." />
                        ) : (
                            accumulatedRows.map((item: any, index: number) => {

                                const formattedDate = formatTodayCompareDateTime(item.sendDate);
                                const contents = item.contents;
                                const isMax = contents.length > 20;
                                const isExpanded = expandedIds.has(item.id);

                                return (
                                    <div className="round-box" key={item.id}>
                                        <div className="push-box">
                                            <p className="time">
                                                {formattedDate}
                                                {!item.readYn && <span className="new"></span>}
                                            </p>
                                            <p className={`txt ${!isExpanded ? 'ellipsis' : ''}`}>
                                                {item.contents}
                                            </p>
                                        </div>
                                        {isMax && <button type="button" className="push-more-btn" onClick={() => toggleExpand(item.id)}>
                                            <i className={`fa ${isExpanded ? 'fa-angle-up' : 'fa-angle-down'}`} aria-hidden="true"></i>
                                        </button>}
                                    </div>
                                );
                            })
                        )}
                    </div>

                    <LoadMoreButton
                        show={showMoreButton && accumulatedRows.length > 0}
                        loading={loadingMore}
                        onClick={handleLoadMore}
                    />
                </section>
            </main>
        </>
    );
};

export default AlarmListPage;